export default "__VITE_ASSET__81f4cf48__"